import { FinalRanking } from "model/Records old/FinalRanking";
import { Tournament } from "model/Tournament/Tournament";
import { EmptyGrowPanelText } from "styles/text";

interface Props {
  tournament: Tournament;
}

export type FinalRankingsTableData = {
  finalRanking: FinalRanking | undefined;
  orgId: string | undefined;
  displayName: string | undefined;
  prize: string | undefined;
  accentColor: string | undefined;
};

// const getFinalRankingsColumns = (
//   showPrizeColumn: boolean
// ): StatTableColumn<FinalRankingsTableData>[] => {
//   const columns = [
//     ctorStatTablePositionColumn({
//       accentGetter: (arg: FinalRankingsTableData) => arg.accentColor,
//       positionGetter: (arg: FinalRankingsTableData) => arg.finalRanking?.rank,
//     }),
//     ctorStatTableOrgLogoNameColumn({
//       orgIdGetter: (arg: FinalRankingsTableData) => arg.orgId,
//       nameGetter: (arg: FinalRankingsTableData) => arg.displayName,
//     }),
//     ctorStatTableTextColumn({
//       textGetter: (arg: FinalRankingsTableData) =>
//         arg.finalRanking?.segmentName,
//     }),
//   ];
//   return showPrizeColumn
//     ? columns.concat(
//         ctorStatTableTextColumn({
//           textGetter: (arg: FinalRankingsTableData) => arg.prize,
//         })
//       )
//     : columns;
// };

export const FinalRankingsTable = ({ tournament }: Props) => {
  return (
    <EmptyGrowPanelText>Unable to calculate final rankings</EmptyGrowPanelText>
  );

  // const allTeamIds =
  //   useAppSelector((state) =>
  //     selectTournamentTeamIds(state, tournament.id)
  //   ) ?? [];
  // const finalRankings = useAppSelector((state) =>
  //   selectTournamentFinalRankings(state, tournament)
  // );

  // const finalRankingTeamIds = Object.keys(finalRankings ?? {});
  // const remainingTeamIds = allTeamIds.filter(
  //   (id) => !finalRankingTeamIds.includes(id)
  // );
  // const sortedTeamIds = !!finalRankings
  //   ? remainingTeamIds.concat(
  //       Object.keys(finalRankings).sort(
  //         (a, b) => finalRankings[a].rank - finalRankings[b].rank
  //       )
  //     )
  //   : [];

  // const data: FinalRankingsTableData[] = useAppSelector((state) =>
  //   !!finalRankings
  //     ? sortedTeamIds.map((teamId) => {
  //         const orgId = selectTeamOrgId(state, teamId, orgTime);
  //         const displayName = selectTeamDisplayName(state, teamId, orgTime);
  //         return {
  //           finalRanking: finalRankings[teamId],
  //           orgId,
  //           displayName,
  //           prize: !!tournament.prizes
  //             ? getPrize(tournament.prizes, finalRankings[teamId]?.rank)
  //             : undefined,
  //           accentColor: !!tournament.rankingGroups
  //             ? getRankingGroup(
  //                 tournament.rankingGroups,
  //                 finalRankings[teamId]?.rank
  //               )?.accentColor
  //             : undefined,
  //         };
  //       })
  //     : []
  // );

  // if (!finalRankings) {
  //   return (
  //     <EmptyGrowPanelText>
  //       Unable to calculate final rankings
  //     </EmptyGrowPanelText>
  //   );
  // }

  // return (
  //   <>
  //     <EmptyGrowPanelText>
  //       Final Rankings may currently be inaccurate, but will be fixed in the
  //       near future
  //     </EmptyGrowPanelText>
  //     <StatTable
  //       stats={data}
  //       columns={getFinalRankingsColumns((tournament.prizes?.length ?? 0) > 0)}
  //       keyGetter={(arg: FinalRankingsTableData) => arg.displayName}
  //     />
  //   </>
  // );
};
